import React from 'react';
import Select from 'react-select';
import moment from 'moment';


const TeeBoxOption = [ { value: 1, label: '1'}, { value: 10, label: '10'}];

const BookSheetHeader = (props) => {
    const {        
        bookingTable, 
        selectedDate,
        selectedTeeBox, 
        setSelectedTeeBox
    } = props;

    function exportSheet(btnType) {
        let fileName = `${moment(selectedDate, 'DD-MM-YYYY').format('DD-MM-YYYY')} - Tee Booking Sheet - ${selectedTeeBox} Tee Box`;

        bookingTable?.update({
            headers: true,
            formats: ["xlsx", "csv"],
            filename: fileName // pass in a new set of properties
        });

        if (btnType == 'xlsx') {
            $('.button-default.xlsx').click();
        } else {
            $('.button-default.csv').click();
        }

        $('.tableexport-caption').addClass('hidden');
    }

    return (<>
    <div className="row">
            <label className="col-form-label col-sm-1 text-right">Date </label>
            <div className="form-group col-xl-3 col-sm-3">
                <div className="input-group date">
                    <input 
                        id="txtDate" 
                        name="txtDate" 
                        type="text" 
                        className="form-control " 
                        placeholder="Select date" 
                        defaultValue={moment(selectedDate, 'DD-MM-YYYY').format('DD-MM-YYYY')} 
                    />
                    <div className="input-group-append">
                        <span className="input-group-text">
                            <i className="la la-calendar-check-o"></i>
                        </span>
                    </div>
                </div>
            </div>
            <label className="col-form-label col-sm-1 text-right pnlSlot ">Tee Box </label>
            <div className="form-group col-sm-2 pnlSlot ">
                <div>
                    <select 
                        id="ddlTeeBox" 
                        name="ddlTeeBox "
                        className="form-control "
                        value={selectedTeeBox}
                        onChange={({target}) => setSelectedTeeBox(target.value)}                     
                    >
                        <option value={1}> 1 </option>
                        <option value={10}> 10 </option>
                    </select>
                </div>
            </div>
            <div className="form-group col-xl-3 col-sm-3">
                <div className="input-group">
                    <div className="kt-input-icon kt-input-icon--left">
                        <input 
                            type="text" 
                            className="form-control clientSearch" 
                            placeholder="Search Tee Time..." 
                            id="generalSearch" 
                        />
                        <span className="kt-input-icon__icon kt-input-icon__icon--left"><span><i className="la la-search"></i></span></span>
                    </div>
                </div>
            </div>
            <div className="col-xl-2 col-sm-2">
                <div className="dropdown">
                    <button className="btn btn-label-brand dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Export
                    </button>
                    <div className="dropdown-menu " aria-labelledby="dropdownMenuButton" x-placement="bottom-start" style={{position: 'absolute', willChange: 'transform', top: '0px', left: '0px', transform: 'translate3d(0px, 38px, 0px)'}}>
                        <button 
                            id="btn-export-excel" 
                            type="button" 
                            className="dropdown-item" 
                            onClick={() => exportSheet('xlsx')}
                        >Excel
                        </button>
                        <button 
                            id="btn-export-csv" 
                            type="button" 
                            className="dropdown-item" 
                            onClick={() => exportSheet('csv')}
                        >Csv 
                        </button>
                    </div>
                </div>
            </div>
        </div>          
    </>);
}

export default BookSheetHeader;
